module.exports = __webpack_public_path__ + "static/media/upwork.1933f411.svg";